'use strict';

var $ = require('jquery');

module.exports = function (options) {
    var context = options.context;

    var dateToday = new Date();

    var dateSpring = new Date(dateToday.getFullYear(), 2, 1, 0, 0, 0);
    var dateSummer = new Date(dateToday.getFullYear(), 5, 1, 0, 0, 0);
    var dateAutumn = new Date(dateToday.getFullYear(), 8, 1, 0, 0, 0);
    var dateWinter = new Date(dateToday.getFullYear(), 11, 1, 0, 0, 0);

    function setup(instance, jqSlideshow, start) {
        jqSlideshow.slick({
            dots: true,
            arrows: true,
            appendArrows: $('[data-binding="species-gallery-nav"]'),
            appendDots: $('[data-binding="species-gallery-image-list"]'),
            prevArrow: '<button class="prev"></button>',
            nextArrow: '<button class="next"></button>',
            initialSlide: start
        });
    }

    function init() {
        context.each(function () {
            var instance = $(this);
            var instanceSlide = instance.find('[data-binding="species-gallery-image-list"]');
            var startPosition = 0;

            if (dateToday >= dateSpring && dateToday < dateSummer) {
                startPosition = instance.find('[data-season="Spring"]').index();
            } else if (dateToday >= dateSummer && dateToday < dateAutumn) {
                startPosition = instance.find('[data-season="Summer"]').index();
            } else if (dateToday >= dateAutumn && dateToday < dateWinter) {
                startPosition = instance.find('[data-season="Autumn"]').index();
            } else {
                startPosition = instance.find('[data-season="Winter"]').index();
            }

            if (startPosition < 0) {
                startPosition = 0;
            }

            setup(instance, instanceSlide, startPosition);
        });
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/species-gallery.js
// module id = 174
// module chunks = 0